import React from 'react'

/* eslint-disable import/prefer-default-export */

export const useAuthenticityToken = (token = '') => {
  const [authenticityToken, updateAuthenticityToken] = React.useState(token)
  return {authenticityToken, updateAuthenticityToken}
}
